import { useMutation } from '@tanstack/react-query';
import { message } from 'antd';

import { finishCreateEditoEventPath } from 'app/routes/edito';
import type { IEditoEventListResponse } from 'app/typings/edito';
import { apiMutation } from 'app/utils/request/api';

type PayloadProps = {
  id: string;
};

export const useFinishEditoEvents = () => {
  return useMutation<IEditoEventListResponse[], unknown, PayloadProps, unknown>(
    {
      mutationFn: async (payload: PayloadProps) =>
        apiMutation(
          'PATCH',
          {
            path: finishCreateEditoEventPath,
            params: { id: payload.id },
          },
          payload
        ),
      onSuccess: () => {
        message.success(
          'The event has been successfully removed from featured'
        );
      },
      onError: () => {
        message.error('Error while removing event from featured');
      },
    }
  );
};
